<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification " + title : "Enregistrement " + title}}
    </h4>
    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="modal-body" [ngBusy]="{
    busy: busySave,
    message: 'Veuillez patienter ...',
    backdrop: false
}">
    <form class="m-1">
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <td colspan="15">
                            <div class="row">
                                <!-- Garant -->
                                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                    <label for="garant_id">
                                        Garant <span class="required_champs">*</span>
                                    </label>
                                    <ng-select 
                                        [disabled]="isAutoFill || itemToSave.isAddBeneficiaire"
                                        (change)="onSelectGarant()" 
                                        [(ngModel)]="itemToSave.garant_id"
                                        placeholder="Choisissez" 
                                        name="garant_id" 
                                        id="garant_id" 
                                        [multiple]="false"
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsGarant;" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Police -->
                                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                    <label for="police_id">
                                        Police <span class="required_champs">*</span>
                                    </label>
                                    <ng-select 
                                        [disabled]="isAutoFill" 
                                        (change)="onSelectPolice()"
                                        [(ngModel)]="itemToSave.police_id" 
                                        placeholder="Choisissez"
                                        name="police_id" 
                                        id="police_id" 
                                        [multiple]="false" 
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsPolice;" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Collège -->
                                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                    <label for="college_id">
                                        Collège <span class="required_champs">*</span>
                                    </label>
                                    <ng-select 
                                        [disabled]="isAutoFill" 
                                        [(ngModel)]="itemToSave.college_id"
                                        placeholder="Choisissez" 
                                        name="college_id" 
                                        id="college_id"
                                        [multiple]="false" 
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsCollege;" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Avenant -->
                                <div class="col-xl-4 col-lg-4 col-md-3 col-sm-6 mb-2 position-relative">
                                    <label for="avenant_id">
                                        Avenant <span class="required_champs">*</span>
                                    </label>
                                    <div class="d-flex">
                                        <ng-select 
                                            [(ngModel)]="itemToSave.avenant_id" 
                                            placeholder="Choisissez"
                                            name="avenant_id" 
                                            id="avenant_id" 
                                            [multiple]="false" 
                                            [closeOnSelect]="true"
                                            class="flex-grow-1">
                                            <ng-option *ngFor="let item of itemsAvenant;" [value]="item.id">
                                                {{item?.libelle}}
                                            </ng-option>
                                        </ng-select>
                                        <button 
                                            type="button"
                                            (click)="openAddAvenant()" 
                                            class="btn btn-success rounded-circle ms-2"
                                            style="width: 40px; height: 40px; padding: 0;"
                                            aria-label="Ajouter avenant">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr class="custom-table-head">
                        <th>#</th>
                        <th>Famille</th>
                        <th>Nom</th>
                        <th>Prénom</th>
                        <th>Genre</th>
                        <th>Statut</th>
                        <th>Codes affections</th>
                        <th>Assuré</th>
                        <th>Numéro CNAM</th>
                        <th>Date naissance</th>
                        <th>Date entrée</th>
                        <th>Téléphone</th>
                        <th>Email</th>
                        <th>Email 2</th>
                        <th>Photo</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of itemsToSaveBenef; let i = index;">
                        <!-- Index -->
                        <td class="text-center">{{i + 1}}</td>

                        <!-- Famille -->
                        <td>
                            <input 
                                type="text"
                                disabled
                                (input)="autoFillFamillyParentMatricule(item); orderByFamille()"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Regroupement"
                                autocomplete="off"
                                [(ngModel)]="item.regroupement_famille" />
                        </td>

                        <!-- Nom -->
                        <td>
                            <input 
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Nom"
                                autocomplete="off"
                                [(ngModel)]="item.nom" />
                        </td>

                        <!-- Prénom -->
                        <td>
                            <input 
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Prénom"
                                autocomplete="off"
                                [(ngModel)]="item.prenom" />
                        </td>

                        <!-- Genre -->
                        <td>
                            <select 
                                class="form-control" 
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="item.genre">
                                <option value="">Sélectionner</option>
                                <option value="M">M</option>
                                <option value="F">F</option>
                            </select>
                        </td>

                        <!-- Statut (duplicate field - should this be different?) -->
                        <td>
                            <select 
                                class="form-control" 
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="item.statut">
                                <option value="">Sélectionner</option>
                                <option value="A">A</option>
                                <option value="C">C</option>
                                <option value="E">E</option>
                                <option value="ASC">ASC</option>
                                <option value="AUT">AUT</option>
                            </select>
                        </td>

                        <!-- Affections -->
                        <td>
                            <input 
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Ex: 10;20"
                                autocomplete="off"
                                [(ngModel)]="item.affections" />
                        </td>

                        <!-- Matricule Assuré -->
                        <td>
                            <input 
                                type="text"
                                (input)="autoFillFamillyParentMatricule(item)"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Matricule"
                                autocomplete="off"
                                [(ngModel)]="item.matricule_assure" />
                        </td>

                        <!-- Numéro CNAM -->
                        <td>
                            <input 
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Numéro CNAM"
                                autocomplete="off"
                                [(ngModel)]="item.numero_cnam" />
                        </td>

                        <!-- Date naissance -->
                        <td>
                            <input 
                                type="text"
                                placeholder="JJ/MM/AAAA"
                                autocomplete="off"
                                class="form-control"
                                bsDatepicker
                                [bsConfig]="{
                                    dateInputFormat: 'DD/MM/YYYY',
                                    containerClass: 'theme-dark-blue'
                                }"
                                [(ngModel)]="item.date_naissance"
                                [ngModelOptions]="{standalone: true}" />
                        </td>

                        <!-- Date entrée -->
                        <td>
                            <input 
                                type="text"
                                placeholder="JJ/MM/AAAA"
                                autocomplete="off"
                                class="form-control"
                                bsDatepicker
                                [bsConfig]="{
                                    dateInputFormat: 'DD/MM/YYYY',
                                    containerClass: 'theme-dark-blue'
                                }"
                                [(ngModel)]="item.date_entree"
                                [ngModelOptions]="{standalone: true}" />
                        </td>

                        <!-- Téléphone -->
                        <td>
                            <input 
                                type="tel"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Téléphone"
                                autocomplete="off"
                                [(ngModel)]="item.telephone" />
                        </td>

                        <!-- Email -->
                        <td>
                            <input 
                                type="email"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Email"
                                autocomplete="off"
                                [(ngModel)]="item.email" />
                        </td>

                        <!-- Email 2 -->
                        <td>
                            <input 
                                type="email"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Email 2"
                                autocomplete="off"
                                [(ngModel)]="item.email2" />
                        </td>

                        <!-- Photo -->
                        <td>
                            <div class="text-center">
                                <img 
                                    *ngIf="item?.file_data?.fullImg"
                                    [src]="item.file_data.fullImg"
                                    alt="Photo bénéficiaire"
                                    class="img-thumbnail mb-2"
                                    style="width: 50px; height: 50px; object-fit: cover;" />
                                
                                <input 
                                    [id]="'img-' + i"
                                    type="file"
                                    class="d-none"
                                    (change)="uploadBenefImageFile($event)"
                                    accept=".png, .jpg, .jpeg, .bmp"
                                    name="photo" />
                                
                                <label 
                                    [for]="'img-' + i"
                                    (click)="currentBenef = item"
                                    class="btn btn-sm btn-primary w-100 mb-0"
                                    style="cursor: pointer;">
                                    Choisir
                                </label>
                            </div>
                        </td>

                        <!-- Actions -->
                        <td class="text-center">
                            <button 
                                type="button"
                                class="btn btn-sm btn-link text-danger p-0"
                                (click)="itemsToSaveBenef.splice(i, 1)"
                                aria-label="Supprimer">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>

                    <tr *ngIf="itemsToSaveBenef?.length === 0">
                        <td colspan="16" class="text-center text-muted py-4">
                            Aucun bénéficiaire ajouté
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="d-flex justify-content-end gap-2 w-100">
        <button 
            type="button"
            class="btn btn-md btn-cancel"
            (click)="bsModalRef.hide()">
            Fermer
        </button>
        
        <button 
            type="button"
            (click)="confirmSaveItemMassData(itemToSave)"
            class="btn btn-md custom_btn_primary"
            [class.auth-spinner]="loading"
            [disabled]="loading || itemsToSaveBenef?.length === 0">
            Sauvegarder
        </button>
    </div>
</div>